export const UNZIP_STRATEGY_VALUES = ["flat", "recursive"] as const;

export const unzipStrategyOptions: Record<
  (typeof UNZIP_STRATEGY_VALUES)[number],
  string
> = {
  flat: "Flat",
  recursive: "Recursive",
};

export const getUnzipStrategyLabel = (
  value: string | null | undefined,
): string => {
  if (!value) return "";
  return (
    unzipStrategyOptions[value as (typeof UNZIP_STRATEGY_VALUES)[number]] ??
    value
  );
};
